import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/root-reducer';
import { searchParamActions, searchParamSelectors } from 'redux/search-param.slice';
import { WsTextField } from 'stories/inputs/WsTextField';

const PriceRange = () => {
  const dispatch = useDispatch();
  const priceMin = useSelector((state: RootState) => searchParamSelectors.priceMin(state));
  const priceMax = useSelector((state: RootState) => searchParamSelectors.priceMax(state));
  const [minVal, setMinVal] = useState('');
  const [maxVal, setMaxVal] = useState('');
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    setMinVal(priceMin);
  }, [priceMin]);

  useEffect(() => {
    setMaxVal(priceMax);
  }, [priceMax]);

  const handleChange = (key: 'min' | 'max', val: string) => {
    setDirty(true);
    if (key === 'min') setMinVal(val);
    else setMaxVal(val);
  };

  const handleBlur = (key: 'min' | 'max') => {
    if (dirty) {
      if (key === 'min') dispatch(searchParamActions.priceMin(minVal));
      else dispatch(searchParamActions.priceMax(maxVal));
      setDirty(false);
    }
  };

  return (
    <Grid container gap={2} paddingTop={1}>
      <Box>
        <Typography variant="subtitle1">Minimum:</Typography>
        <WsTextField
          id="priceMin"
          placeholder="Any"
          width={90}
          value={minVal}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange('min', event.target.value)}
          onBlur={() => handleBlur('min')}
          currency
          useCheck
        />
      </Box>
      <Box>
        <Typography variant="subtitle1">Maximum:</Typography>
        <WsTextField
          id="priceMax"
          placeholder="Any"
          width={90}
          value={maxVal}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange('max', event.target.value)}
          onBlur={() => handleBlur('max')}
          currency
          useCheck
        />
      </Box>
    </Grid>
  );
};

export default PriceRange;
